import { DIALOG_WIDTH, VIEW_HEIGHT } from "../../constants/dimensions.es.js";
import styled from "../../../../material/styles/styled.es.js";
const PickerViewRoot = styled("div")({
  overflow: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
export {
  PickerViewRoot
};
//# sourceMappingURL=PickerViewRoot.es.js.map
